import { createSelector } from '@reduxjs/toolkit'
import config from 'constants/config'
import { OptimizelyFeatureFlags } from 'constants/optimizely'

export const isLebtServiceFeesEnabled = createSelector(
  (state: App.State) => state.optimizely.optimizelyFeatureFlags,
  (optimizelyFeatureFlags): boolean => {
    return !!(config.businessTraveller.currentAccountMode === 'business' &&
      optimizelyFeatureFlags[OptimizelyFeatureFlags.lebtServiceFeesEnabled])
  },
)
